import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { PagesID } from "@utils/utilsConfigurations";
import EnrollmentListShell from "../components/EnrollmentListShell";
import EnrolledGroupRow from "../components/EnrolledGroupRow";
import { useEnrolledGroupsList } from "../hooks/useEnrolledGroupsList";

const PAGE_SIZE = 10;

interface EnrolledGroupsTabProps {
  corporateId: string | number;
  objectId: number;
}

const EnrolledGroupsTab: React.FC<EnrolledGroupsTabProps> = ({
  corporateId,
  objectId,
}) => {
  const { t } = useTranslation("users-and-groups");
  const { t: tInput } = useTranslation("input");

  const enrollTypeOptions = [
    "top_mandatory",
    "top",
    "pre_auto",
    "pre_bottom",
  ].map((key) => ({
    value: key.toUpperCase(),
    label: String(tInput(`options.enroll_type.${key}`)),
  }));
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [search, setSearch] = useState("");
  const [fieldFilters, setFieldFilters] = useState<Record<string, any>>({});

  const { items, totalItems, totalPages, isLoading } = useEnrolledGroupsList({
    corporateId,
    objectId,
    page,
    pageSize,
    search: search || undefined,
    fieldFilters,
  });

  return (
    <EnrollmentListShell
      search={search}
      onSearchSubmit={(v) => {
        setSearch(v);
        setPage(1);
      }}
      hideSearch
      filtersPageId={PagesID["corporate.catalog.courses.subscribed.groups"]}
      filtersDynamicOptions={{ enrollmentType: enrollTypeOptions }}
      fieldFilters={fieldFilters}
      onApplyFilters={(next) => {
        setFieldFilters(next);
        setPage(1);
      }}
      isLoading={isLoading}
      isEmpty={items.length === 0}
      emptyLabel={String(t("empty.enrolled-groups"))}
      page={page}
      pageSize={pageSize}
      totalItems={totalItems}
      totalPages={totalPages}
      onPageChange={setPage}
      onPageSizeChange={(next) => {
        setPageSize(next);
        setPage(1);
      }}
    >
      {items.map((group) => (
        <EnrolledGroupRow
          key={group.id}
          group={group}
          // TODO: riattivare "Vai al gruppo" quando esisterà il detail del gruppo
          // onGoToGroup={(g) => navigate(...)}
        />
      ))}
    </EnrollmentListShell>
  );
};

export default EnrolledGroupsTab;
